// Definition of the Tag service API following AIP standards.

// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/workspace/v1/tag_api.proto (package ai.h2o.workspace.v1, syntax proto3)
/* eslint-disable */

import type { Tag } from "./tag_pb";
import { RPC } from "../../../../runtime";

/**
 * @generated from message ai.h2o.workspace.v1.GetTagRequest
 */
export type GetTagRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.GetTagResponse
 */
export type GetTagResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Tag tag = 1;
 */
tag?: Tag;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CreateTagRequest
 */
export type CreateTagRequest = {
/**
 * The tag to create.
 *
 * @generated from field: ai.h2o.workspace.v1.Tag tag = 1;
 */
tag?: Tag;
/**
 * Required.
 * The tag ID to use for this tag.
 * Must match ^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$ regular expression.
 *
 * @generated from field: string tag_id = 2;
 */
tagId?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.CreateTagResponse
 */
export type CreateTagResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Tag tag = 1;
 */
tag?: Tag;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UpdateTagRequest
 */
export type UpdateTagRequest = {
/**
 * @generated from field: ai.h2o.workspace.v1.Tag tag = 1;
 */
tag?: Tag;
/**
 * Only the fields specified in the update_mask are updated.
 *
 * Updatable fields are:
 *  - display_name
 *  - description
 * - annotations and annotations.key
 *
 * @generated from field: google.protobuf.FieldMask update_mask = 2;
 */
updateMask?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.UpdateTagResponse
 */
export type UpdateTagResponse = {
/**
 * @generated from field: ai.h2o.workspace.v1.Tag tag = 1;
 */
tag?: Tag;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.DeleteTagRequest
 */
export type DeleteTagRequest = {
/**
 * @generated from field: string name = 1;
 */
name?: string;
}
;
/**
 * @generated from message ai.h2o.workspace.v1.DeleteTagResponse
 */
export type DeleteTagResponse = {
}
;
/**
 * Request message for ListTags method.
 *
 * @generated from message ai.h2o.workspace.v1.ListTagsRequest
 */
export type ListTagsRequest = {
/**
 * The maximum number of tags to return.
 *
 * @generated from field: int32 page_size = 1;
 */
pageSize?: number;
/**
 * A pagination token returned from a previous call.
 *
 * @generated from field: string page_token = 2;
 */
pageToken?: string;
/**
 * When used, server will only return tags that match the filter.
 * Attempts to generally implement AIP-160 (https://aip.dev/160)
 * specification.
 * See https://github.com/h2oai/authz-server/blob/main/docs/adopting.md#filtering for specific supported
 * features.
 *
 * Supported fields:
 *   * display_name
 *   * description
 *
 * Fields that are used for literal string matching:
 *  * display_name
 *  * description
 *  * identifier part of the name
 *
 * @generated from field: string filter = 3;
 */
filter?: string;
}
;
/**
 * Response message for ListTags method.
 *
 * @generated from message ai.h2o.workspace.v1.ListTagsResponse
 */
export type ListTagsResponse = {
/**
 * @generated from field: repeated ai.h2o.workspace.v1.Tag tags = 1;
 */
tags?: Tag[];
/**
 * A token to retrieve the next page of results.
 *
 * @generated from field: string next_page_token = 2;
 */
nextPageToken?: string;
}
;
/**
 * Returns details of the tag specified by the name.
 * Authorized by the "actions/workspaceserver/tags/READ" action on the
 * //workspaceserver resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.TagService.GetTag
 */
export const TagService_GetTag = new RPC<GetTagRequest,GetTagResponse>("GET", "/v1/{name=tags/*}");
/**
 * Creates a new tag.
 * Authorized by the "actions/workspaceserver/tags/WRITE" action on the
 * //workspaceserver resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.TagService.CreateTag
 */
export const TagService_CreateTag = new RPC<CreateTagRequest,CreateTagResponse>("POST", "/v1/tags", "tag");
/**
 * Updates the tag specified by the name.
 * Authorized by the "actions/workspaceserver/tags/WRITE" action on the
 * //workspaceserver resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.TagService.UpdateTag
 */
export const TagService_UpdateTag = new RPC<UpdateTagRequest,UpdateTagResponse>("PATCH", "/v1/{tag.name=tags/*}", "tag");
/**
 * Deletes the tag specified by the name.
 * Authorized by the "actions/workspaceserver/tags/WRITE" action on the
 * //workspaceserver resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.TagService.DeleteTag
 */
export const TagService_DeleteTag = new RPC<DeleteTagRequest,DeleteTagResponse>("DELETE", "/v1/{name=tags/*}");
/**
 * Lists tags.
 * Authorized by the "actions/workspaceserver/tags/READ" action on the
 * //workspaceserver resource.
 *
 * @generated from rpc ai.h2o.workspace.v1.TagService.ListTags
 */
export const TagService_ListTags = new RPC<ListTagsRequest,ListTagsResponse>("GET", "/v1/tags");
